import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInfoResponse } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import { SERVICE } from "constants/global";
import pointAPI from "api/pointAPI";
import noticeAPI from "api/noticeAPI";

const getMyPoint = createAsyncThunk(
  "GET_MY_POINT",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await Promise.all([
        pointAPI.getPointList(_arg),
        noticeAPI.getInitNotice({ service: SERVICE }),
      ]);
      dispatch(saveUserInfo(getInfoResponse(res[0])));
      if( res[0].sorrypage == '0' && res[1].sorrypage == '0') {
        return {
          isInLine: true,
          point: {},
          notice: {},
        }
      }
      return {
        isInLinePoint: res[0].sorrypage == '0' ? true : res[0].data.isInLine,
        isInLineNotice: res[1].sorrypage == '0' ? true : res[1].isInLine,
        point: res[0].data.point,
        notice: res[1].message?.notice,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  points: null,
  total_point: null,
  noticesInit: null,
  isInLine: false
};

const pointSlice = createSlice({
  name: "point",
  initialState,
  extraReducers: {
    [getMyPoint.fulfilled]: (state, action) => {
      state.points = action.payload.point?.points;
      state.total_point = action.payload.point?.total_point;
      state.noticesInit = action.payload.notice;
      state.isInLine = action.payload.isInLine;
      state.isInLinePoint = action.payload.isInLinePoint;
      state.isInLineNotice = action.payload.isInLineNotice;
    },
  },
});

const { reducer } = pointSlice;
export { getMyPoint };
export default reducer;
